import React from 'react';
import PropTypes from 'prop-types';
import './modal.css';
import { Link } from 'react-router-dom';
import { TfiClose } from "react-icons/tfi";

const MenuModal = ({ CloseMenuModal }) => (
  <div className="menu-mobile modal animate__animated animate__backInRight">
    <div className="modal-content">
      <ul>
        <button type="button" className="close" onClick={CloseMenuModal}><TfiClose/></button>
        <Link className="m-links" onClick={CloseMenuModal} to="/">Home</Link>
        <Link className="m-links" onClick={CloseMenuModal} to="/projects"> Porfolio</Link>
        <Link className="m-links" onClick={CloseMenuModal} to="/about"> About</Link>
        <Link className="m-links" onClick={CloseMenuModal} to="/contact"> Contact</Link>
      </ul>
    </div>
  </div>
);

MenuModal.propTypes = {
  CloseMenuModal: PropTypes.func.isRequired,
};

export default MenuModal;
